import { useEffect, useState } from 'react';
import {
  ACTIVATE_ANNOTATION_EVENT,
  ANNOTATABLE_SELECTION_CLEAR_EVENT,
  ANNOTATABLE_SELECTION_EVENT,
  CANCEL_CREATE_ANNOTATION_EVENT,
  CREATE_ANNOTATION_EVENT,
  CREATE_TMP_ANNOTATION_EVENT
} from '@contently/editor';
import { uuid } from 'uuidv4';
import { useFetcher } from 'rest-hooks';
import AnnotationResource from '../resources/AnnotationResource';

function getRelativePosition(coords, positionContainerRef) {
  return function stateSetter() {
    const box = positionContainerRef.current.getBoundingClientRect();
    return coords.top - box.top - 14;
  };
}

export default function useTextEditorAnnotations(
  consumerApi,
  contentId,
  allContentIds,
  positionContainerRef
) {
  const [showCommentButton, setShowCommentButton] = useState(false);
  const [showCommentForm, setShowCommentForm] = useState(false);
  const [activeAnnotation, setActiveAnnotation] = useState(null);
  const [yPos, setYPos] = useState('0px');
  const createAnnotation = useFetcher(AnnotationResource.createShape());

  useEffect(() => {
    consumerApi.on(ANNOTATABLE_SELECTION_EVENT, ({ range, coords }) => {
      setYPos(getRelativePosition(coords, positionContainerRef));
      setShowCommentButton(true);
    });
    consumerApi.on(CREATE_ANNOTATION_EVENT, () => setShowCommentForm(false));
    consumerApi.on(ANNOTATABLE_SELECTION_CLEAR_EVENT, () => setShowCommentButton(false));
    consumerApi.on(ACTIVATE_ANNOTATION_EVENT, ({ uuid, coords }) => {
      setYPos(getRelativePosition(coords, positionContainerRef));
      setActiveAnnotation(uuid);
    });
  }, [consumerApi, positionContainerRef]);

  const handleNewAnnotation = () => {
    consumerApi.emit(CREATE_TMP_ANNOTATION_EVENT, setShowCommentForm(true));
    setShowCommentButton(false);
  };

  const handleSubmitComment = async ({ body }) => {
    const markId = uuid();
    const data = {
      target_type: 'Content',
      target_id: contentId,
      type: 'Annotation::Text',
      mark_id: markId,
      highlighted_text: 'words', // replace when api returns highlighted_text
      comment_attributes: {
        body
      }
    };

    await createAnnotation({}, data, [
      [
        AnnotationResource.listShape(),
        { target_id: allContentIds, target_type: 'Content' },
        (newAnnotationId, annotationIds) => {
          return [...(annotationIds || []), newAnnotationId];
        }
      ]
    ]);
    consumerApi.emit(CREATE_ANNOTATION_EVENT, markId);
  };

  const handleCancelComment = () => {
    consumerApi.emit(CANCEL_CREATE_ANNOTATION_EVENT, setShowCommentForm(false));
  };

  return {
    showCommentButton,
    showCommentForm,
    activeAnnotation,
    setActiveAnnotation,
    handleNewAnnotation,
    handleSubmitComment,
    handleCancelComment,
    yPos
  };
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useTextEditorAnnotations.js